import React from "react"
import { Link } from "react-router-dom"
import { useFixedFeesOverview } from "./../hooks/useFixedFeesOverview"
import { buildModuleVOConfigUrl, buildModuleVOEditUrl } from "./../moduleVoNavigation"

export default function OverviewFixedFees() {

    const {
        brandConfigs,
        siteConfigs,
        globalLinesConfigured,
        deleteConfig,
    } = useFixedFeesOverview()

    const handleDelete = (target: { dealershipIds: number[], brands: string[] }) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer définitivement cette configuration ?')) {
            deleteConfig(target)
        }
    }

    return (
        <>
            <div className="tw-flex tw-flex-col tw-gap-5 tw-px-2">
                <div className="tw-flex tw-flex-col tw-gap-3">
                    <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
                        <span className="tw-text-xl">Paramétrage par marque</span>
                        <Link to={buildModuleVOConfigUrl('fixedFees', 'brand')} className="btn btn-primary tw-text-sm">
                            <i className="fa fa-plus tw-mr-2"></i>
                            Ajouter une config par marque
                        </Link>
                    </div>
                    <div className="tw-flex tw-flex-col tw-gap-4">
                        <div>
                            <table className="table table-striped table-hover table-sm">
                                <thead>
                                <tr>
                                    <th>Marque</th>
                                    <th>Site</th>
                                    <th>Ligne paramétrées</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {brandConfigs.length === 0 && (
                                    <tr>
                                        <td className="tw-text-sm tw-text-muted" colSpan={4}>Aucune configuration par marque</td>
                                    </tr>
                                )}
                                {brandConfigs.map((brandConfig, index) => (
                                    <tr key={`${brandConfig.brand}_${index}`}>
                                        <td className="tw-text-sm">{brandConfig.brand}</td>
                                        <td className="tw-text-sm">{brandConfig.siteLabel}</td>
                                        <td className="tw-text-sm">{brandConfig.linesConfigured.active}/{brandConfig.linesConfigured.total}</td>
                                        <td className="text-center">
                                            <div className="tw-flex tw-flex-row tw-gap-2 tw-justify-center">
                                                <Link
                                                    to={buildModuleVOEditUrl('fixedFees', { brand: brandConfig.brand, dealershipIds: brandConfig.dealershipIds })}
                                                    className="tw-text-sm tw-text-blue-500 tw-border-0 tw-bg-blue-500 tw-rounded tw-px-2 tw-py-1"
                                                    title="Modifier"
                                                >
                                                    <i className="fa fa-edit tw-text-white"></i>
                                                </Link>
                                                <button
                                                    className="tw-text-sm tw-border-0 tw-bg-red-500 tw-rounded tw-px-2 tw-py-1"
                                                    title="Supprimer"
                                                    onClick={() => handleDelete({ dealershipIds: brandConfig.dealershipIds, brands: [ brandConfig.brand ] })}
                                                >
                                                    <i className="fa fa-trash tw-text-white"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-3">
                    <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
                        <span className="tw-text-xl">Paramétrage par Site</span>
                        <Link to={buildModuleVOConfigUrl('fixedFees', 'site')} className="btn btn-primary tw-text-sm">
                            <i className="fa fa-plus tw-mr-2"></i>
                            Ajouter une config par site
                        </Link>
                    </div>
                    <div className="tw-flex tw-flex-col tw-gap-4">
                        <div>
                            <table className="table table-striped table-hover table-sm">
                                <thead>
                                <tr>

                                    <th>Site</th>
                                    <th>Ligne paramétrées</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {siteConfigs.length === 0 && (
                                    <tr>
                                        <td className="tw-text-sm tw-text-muted" colSpan={3}>Aucune configuration par site</td>
                                    </tr>
                                )}
                                {siteConfigs.map(siteConfig => (
                                    <tr key={siteConfig.dealershipId}>

                                        <td className="tw-text-sm">{siteConfig.siteName}</td>
                                        <td className="tw-text-sm">{siteConfig.linesConfigured.active}/{siteConfig.linesConfigured.total}</td>
                                        <td className="text-center">
                                            <div className="tw-flex tw-flex-row tw-gap-2 tw-justify-center">
                                                <Link
                                                    to={buildModuleVOEditUrl('fixedFees', { dealershipIds: [ siteConfig.dealershipId ] })}
                                                    className="tw-text-sm tw-text-blue-500 tw-border-0 tw-bg-blue-500 tw-rounded tw-px-2 tw-py-1"
                                                    title="Modifier"
                                                >
                                                    <i className="fa fa-edit tw-text-white"></i>
                                                </Link>
                                                <button
                                                    className="tw-text-sm tw-border-0 tw-bg-red-500 tw-rounded tw-px-2 tw-py-1"
                                                    title="Supprimer"
                                                    onClick={() => handleDelete({ dealershipIds: [ siteConfig.dealershipId ], brands: [] })}
                                                >
                                                    <i className="fa fa-trash tw-text-white"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-3">
                    <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
                        <span className="tw-text-xl">Paramétrage global</span>
                        {globalLinesConfigured.total > 0 ? (
                            <button className="btn btn-primary tw-text-sm" disabled>
                                <i className="fa fa-plus tw-mr-2"></i>
                                Ajouter une config globale
                            </button>
                        ) : (
                            <Link to={buildModuleVOConfigUrl('fixedFees', 'global')} className="btn btn-primary tw-text-sm">
                                <i className="fa fa-plus tw-mr-2"></i>
                                Ajouter une config globale
                            </Link>
                        )}
                    </div>
                    <div className="tw-flex tw-flex-col tw-gap-4">
                        <div>
                            <table className="table table-striped table-hover table-sm">
                                <thead>
                                <tr>

                                    <th>Ligne paramétrées</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {globalLinesConfigured.total === 0 && (
                                    <tr>
                                        <td className="tw-text-sm tw-text-muted" colSpan={2}>Aucune configuration globale</td>
                                    </tr>
                                )}
                                {globalLinesConfigured.total > 0 && (
                                    <tr>
                                        <td className="tw-text-sm">{globalLinesConfigured.active}/{globalLinesConfigured.total}</td>
                                        <td className="text-center">
                                            <div className="tw-flex tw-flex-row tw-gap-2 tw-justify-center">
                                                <Link
                                                    to={buildModuleVOEditUrl('fixedFees', {})}
                                                    className="tw-text-sm tw-text-blue-500 tw-border-0 tw-bg-blue-500 tw-rounded tw-px-2 tw-py-1"
                                                    title="Modifier"
                                                >
                                                    <i className="fa fa-edit tw-text-white"></i>
                                                </Link>
                                                <button
                                                    className="tw-text-sm tw-border-0 tw-bg-red-500 tw-rounded tw-px-2 tw-py-1"
                                                    title="Supprimer"
                                                    onClick={() => handleDelete({ dealershipIds: [], brands: [] })}
                                                >
                                                    <i className="fa fa-trash tw-text-white"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
